<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <div class="form-list-usaha">
      <div class="list-usaha">
        <div class="list-usaha-content list-usaha-content__title">
          <p class="column20 mr10">Dokumen</p>
          <p class="column15 mr10">No Dokumen</p>
          <p class="column15 mr10">Masa Berlaku</p>
          <p class="column15">Tanggal Efektif</p>
          <p class="column15">Tanggal Berakhir</p>
          <p class="column15"></p>
        </div>
        <div v-for="(list, index) in model" :key="index">
          <div class="list-usaha-content" v-if="list['checked']">
            <p class="column20 mr10 all-column">{{ list.desc }}</p>
            <p class="column15 mr10">
              <input style="width: 90%" type="text" v-model="model[index]['no_doc']" :disabled="disabled" />
            </p>
            <p class="column15 mr10 all-column">
              <input type="checkbox" :value="true" v-model="model[index]['is_lifetime']" :disabled="disabled" />
              Seumur Hidup
            </p>
            <p class="column15">
              <input style="width: 90%" type="date" v-model="model[index]['start_date']" :disabled="disabled" />
            </p>
            <p class="column15">
              <input style="width: 90%" type="date" v-model="model[index]['end_date']" :disabled="disabled" />
            </p>
            <p class="column15">
              <label class="btn btn-default btn-file column100">
                <i class="fas fa-download" @click="downloadFile(list.lampiran)"></i>
                <span class="all-column">{{
        $get(list, 'fileName', 'Upload')
      }}</span>
                <input type="file" style="display: none;" @change="filePerizinanChangeHandler($event, index)"
                  :disabled="disabled" />
              </label>
            </p>
          </div>
        </div>
        <div @click="openModal()" class="btn-landing-icons" v-if="!disabled">
          <p class="icons-btn-landing">+</p>
          <a class="text-btn-landing">Tambah</a>
        </div>
      </div>
    </div>
    <AddAktaPerusahaan v-if="$store.state[storeName].addAktaPerusahaan" />
    <AddKomersial v-if="$store.state[storeName].addKomersial" />
    <AddPerizinan v-if="$store.state[storeName][modalName]" :label="label" :modalName="modalName" :storeName="storeName"
      :modelName="modelName" :mutationName="mutationName" />
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  props: [
    'label',
    'modelName',
    'isRequired',
    'mutationName',
    'storeName',
    'modalName',
    'disabled',
  ],
  components: {
    AddAktaPerusahaan: () =>
      import('@/components/modalLandingPage/addAktaPerusahaan.vue'),
    AddKomersial: () =>
      import('@/components/modalLandingPage/addKomersial.vue'),
    AddPerizinan: () => import('@/components/customModal/addPerizinan.vue'),
  },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {
    model: function () {
      return this.$store.state[this.storeName][this.modelName]
    },
  },
  methods: {
    openModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
    },
    filePerizinanChangeHandler(e, i) {
      let oldPerizinan = this.$store.state[this.storeName][this.modelName]

      let perizinanFiles = Array.from(e.target.files)

      oldPerizinan[i]['file'] = perizinanFiles
      oldPerizinan[i]['fileName'] = perizinanFiles[0].name

      this.$store.commit(this.mutationName, {
        name: this.modelName,
        value: [],
      })
      this.$store.commit(this.mutationName, {
        name: this.modelName,
        value: oldPerizinan,
      })
    },
    async downloadFile(link) {


      if (link) {
        let linkUrl = `${api}/file/${link}`
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
  },
}
</script>
